import { Card, Divider, Stack, Text } from "@towersystems/roam-common-native";
import {
  CategorizationFieldset,
  CategorizationFieldsetProps,
  NameFormInput,
  NameFormInputProps,
  StockNumberFormInput,
  StockNumberFormInputProps,
} from "./components";
import {
  PricingFieldset,
  PricingFieldsetProps,
} from "./components/PricingFieldset";
import {
  SupplierFieldset,
  SupplierFieldsetProps,
} from "./components/SupplierFieldset";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "./types";
import { LocationIdToName } from "../../../../components";
import { Spacings, View } from "react-native-ui-lib";
import {
  SerialNumbersFieldset,
  SerialNumbersFieldsetProps,
} from "./components/SerialNumbersFieldset";
import { PriceLookUpFormInput } from "./components/PriceLookUpFormInput";
import {
  DescriptionFormInput,
  DescriptionFormInputProps,
} from "./components/DescriptionFormInput";
import {
  WeightFormInput,
  WeightFormInputProps,
} from "./components/WeightFormInput";
import { SelectedOptionsFieldArray } from "./components/SelectedOptionsFieldArray/SelectedOptionsFieldArray";

export type ProductFormProps = {} & CategorizationFieldsetProps &
  PricingFieldsetProps &
  SupplierFieldsetProps &
  SerialNumbersFieldsetProps &
  WeightFormInputProps &
  StockNumberFormInputProps &
  NameFormInputProps &
  DescriptionFormInputProps;

export const ProductForm = ({
  onSelectDepartmentPress,
  onSelectCategoryPress,
  onSelectTaxGroupPress,
  onSelectSupplierPress,
  onManageSerialNumbersPress,
  onManageTagsPress,
  onGenerateBarcodePress,
  onSelectUomPress,
  onStockNumberFormInputBlur,
  onLlmQuickWinButtonPress,
  onProductNameLlmQuickWinButtonPress,
  onTagsLlmQuickWinButtonPress,
  onRetailPricingLlmQuickWinButtonPress,
}: ProductFormProps) => {
  const { watch } = useFormContext<ProductFormValues>();

  const watchedLocationId = watch("locationId");
  const watchedSelectedOptions = watch("selectedOptions");
  const locationTitleMarkup = watchedLocationId ? (
    <View style={{ marginBottom: Spacings.s5 }} row>
      <Text variant="heading4" fontWeight="bold">
        PRICING
      </Text>
      <Text>{` (`}</Text>
      <LocationIdToName
        locationId={watchedLocationId}
        variant="heading4"
        fontWeight="bold"
      />
      <Text>{`)`}</Text>
    </View>
  ) : undefined;

  return (
    <Stack vertical>
      <Card title="PRODUCT DETAILS">
        <Stack vertical>
          <StockNumberFormInput
            onGenerateBarcodePress={onGenerateBarcodePress}
            onStockNumberFormInputBlur={onStockNumberFormInputBlur}
          />
          <NameFormInput
            onProductNameLlmQuickWinButtonPress={
              onProductNameLlmQuickWinButtonPress
            }
          />
          <DescriptionFormInput
            onLlmQuickWinButtonPress={onLlmQuickWinButtonPress}
          />
          <PriceLookUpFormInput />
          <WeightFormInput onSelectUomPress={onSelectUomPress} />
        </Stack>
      </Card>

      {watchedSelectedOptions?.length > 0 && (
        <>
          <Divider />
          <Card title="Variant Options">
            <SelectedOptionsFieldArray />
          </Card>
        </>
      )}

      <Divider />
      <Card title="Categorization">
        <CategorizationFieldset
          onSelectCategoryPress={onSelectCategoryPress}
          onSelectDepartmentPress={onSelectDepartmentPress}
          onManageTagsPress={onManageTagsPress}
          onTagsLlmQuickWinButtonPress={onTagsLlmQuickWinButtonPress}
        />
      </Card>
      <Divider />
      <Card title="Pricing" titleComponent={locationTitleMarkup}>
        <PricingFieldset
          onSelectTaxGroupPress={onSelectTaxGroupPress}
          onRetailPricingLlmQuickWinButtonPress={
            onRetailPricingLlmQuickWinButtonPress
          }
        />
      </Card>
      <Divider />
      <Card title="Supplier">
        <SupplierFieldset onSelectSupplierPress={onSelectSupplierPress} />
      </Card>
      <Divider />
      <Card title="Serial numbers">
        <SerialNumbersFieldset
          onManageSerialNumbersPress={onManageSerialNumbersPress}
        />
      </Card>
    </Stack>
  );
};

ProductForm.NameFormInput = NameFormInput;
ProductForm.StockNumberFormInput = StockNumberFormInput;
ProductForm.CategorizationFieldset = CategorizationFieldset;
ProductForm.SupplierFieldset = SupplierFieldset;
ProductForm.PriceLookUpFormInput = PriceLookUpFormInput;
ProductForm.PricingFieldset = PricingFieldset;
ProductForm.WeightFormInput = WeightFormInput;
ProductForm.SelectedOptionsFieldArray = SelectedOptionsFieldArray;
ProductForm.SerialNumbersFieldset = SerialNumbersFieldset;
ProductForm.DescriptionFormInput = DescriptionFormInput;
